import React, { useEffect, useState } from 'react'
import Switch from "react-switch";
import { Button, Collapse } from 'reactstrap';
import { useDispatch, useSelector } from "react-redux";
import colors from "../formColors.js"
import getFilters from '../../../api/getFilters.js';
import { addFilter } from '../../../redux/filtersSlice';
import { toggleReloadFilters } from '../../../redux/selectedProjectSlice.js';

// const MockData = [
//     {
//         "id": 1,
//         "name": "Form Name Key Name",
//         "value": "some value",
//         "checked": false
//     },
//     {
//         "id": 2,
//         "name": "Form Name 2 Key Name 2",
//         "value": "some other value",
//         "checked": false
//     },
//     {
//         "id": 3,
//         "name": "Form Name Key Name",
//         "value": "some value",
//         "checked": true
//     }
// ]

let MockData = [];

const createMockData = () => {
    MockData = [];
    for (let i = 0; i < 50; i++) {
        MockData.push(
            {
                "id": i + 1,
                "name": "Form Name Key Name",
                "value": "",
                "checked": false,
                "operator": "null",
                "conditionoperator": "lt",
                "form_index": "",
                "data_index": "",
            }
        );
    }
}

const Filters = () => {
    const selectedProject = useSelector(state => state.selectedProject);
    const forms = useSelector(state => state.forms)
    const allfilters = useSelector(state => state.filters)
    const researchTableData = useSelector(state => state.research.tables)
    const [data, setData] = useState([...MockData])
    const [isCollapseOpen, setIsCollapseOpen] = useState(true);
    const [filters, setFilters] = useState([]);
    const [OriginalFilters, setOriginalFilters] = useState([]);
    const [FilterArray, setFilterArray] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        if (selectedProject.reloadFilters || MockData.length === 0) {
            createMockData()
            dispatch(toggleReloadFilters(false))
        }
    }, []);

    useEffect(() => {
        const arrdata = [...MockData]
        arrdata.sort((a, b) => a.checked ? -1 : 1)
        setData(arrdata)
    }, []);

    useEffect(() => {
        if (allfilters.length > 0) {
            setOriginalFilters(allfilters);
        }
    }, [allfilters]);

    const getFilterList = (forms, index) => {
        if (index < forms.length) {
            getFilters(selectedProject.name, forms[index])
                .then(res => {
                    setFilters(prev => ([...prev, res.data.researchKeys]));
                    getFilterList(forms, index + 1)
                });
        }
    }

    useEffect(() => {
        setFilters([]);
        getFilterList(forms, 0)
        // dispatch(addFilter(filters))
    }, [forms.length])

    const handleChange = (e, elem, form, val, index, type, dataIndex, checkedVal) => {
        var allfilterArray = OriginalFilters;
        if (type === 'Checked') {
            var newArraytoPush = allfilterArray?.[index] ? allfilterArray?.[index] : [];
            var formIdVal = researchTableData.find(i => i.form_name === form)?.form_id;
            var filtersContent = { form_index: index, data_index: dataIndex, checked: checkedVal, form_id: formIdVal, form_name: form, condition: { column: val, operator: "lt", value: "" } };
            FilterArray[index][dataIndex ? dataIndex : 0].checked = checkedVal;
            FilterArray[index][dataIndex ? dataIndex : 0].form_id = formIdVal;
            setFilterArray([...FilterArray]);
            if (newArraytoPush.length > 0) {
                filtersContent.operator = "and";
            }
            else {
                filtersContent.operator = "null";
            }
            if (FilterArray?.[index]?.[dataIndex]?.condition) {
                var newVarValue = { ...FilterArray[index][dataIndex].condition };
                filtersContent.condition.value = newVarValue.value;
                filtersContent.condition.operator = newVarValue.operator;
            }
            if (FilterArray?.[index]?.[dataIndex]?.operator && newArraytoPush.length > 0) {
                filtersContent.operator = FilterArray?.[index]?.[dataIndex]?.operator;
            }
            if (checkedVal === true && newArraytoPush[dataIndex] === undefined) {
                newArraytoPush[dataIndex] = filtersContent;
            }
            else {
                if (newArraytoPush[dataIndex] !== undefined) {
                    newArraytoPush[dataIndex]['checked'] = checkedVal;
                }
            }
            if (checkedVal === true && allfilterArray[index] === undefined) {
                allfilterArray[index] = newArraytoPush;
            }

        }
        if (type === 'ConditionOperator') {
            if (allfilterArray?.[index]?.[dataIndex] !== undefined) {
                var inputvalue = e.target.value;
                const cond = { ...allfilterArray[index][dataIndex].condition };
                if (cond['operator'] !== undefined) {
                    cond.operator = inputvalue;
                    allfilterArray[index][dataIndex].condition = cond;
                }
            }
            // console.log("allfilterArray ==>", allfilterArray);    
            if (FilterArray?.[index]?.[dataIndex]?.condition) {
                var inputvalue1 = e.target.value;
                const cond1 = { ...FilterArray[index][dataIndex].condition };
                if (cond1.operator != undefined) {
                    cond1.operator = inputvalue1;
                    FilterArray[index][dataIndex].condition = cond1;
                    setFilterArray([...FilterArray]);
                }
            }
            const arr = [...data]
            arr.map(item => {
                if (item.id == elem.id) {
                    item.conditionoperator = e.target.value
                }
                return item
            });
            setData([...arr]);
        }
        if (type === 'OperatorChange') {
            var newdtaIndex = dataIndex + 1;
            if (allfilterArray?.[index]?.[newdtaIndex]?.operator) {
                allfilterArray[index][newdtaIndex].operator = e.target.value;
            }
            if (FilterArray?.[index]?.[newdtaIndex]?.operator) {
                FilterArray[index][newdtaIndex].operator = e.target.value;
                // setFilterArray([...FilterArray]);
            }
            if (FilterArray?.[index + 1]?.[dataIndex]?.operator) {
                FilterArray[index + 1][dataIndex].operator = e.target.value;
                // setFilterArray([...FilterArray]);
            }
            setFilterArray([...FilterArray]);
            const arr = [...data]
            arr.map(item => {
                if (item.id == elem.id) {
                    item.operator = e.target.value
                }
                return item
            });
            setData([...arr]);
        }
        if (type === 'Checked') {
            const arr = [...data]
            arr.map(item => {
                if (item.id == elem.id) {
                    item.checked = !item.checked;
                    item.form_index = index;
                    item.data_index = dataIndex;
                }
                return item
            });
            const arrdata = [...arr]
            arrdata.sort((a, b) => a.checked ? - 1 : 1)
            setData([...arrdata]);
        }
        if (type === 'ValueChange') {
            const arr = [...data];
            arr.map(item => {
                if (item.id == elem.id) {
                    item.value = e.target.value
                }
                return item;
            })
            setData([...arr]);

            if (allfilterArray?.[index]?.[dataIndex] !== undefined) {
                var inputvalue = e.target.value;
                const cond = { ...allfilterArray[index][dataIndex].condition };
                if (cond['value'] != undefined) {
                    cond.value = inputvalue;

                    allfilterArray[index][dataIndex].condition = cond;
                }
            }
            if (FilterArray?.[index]?.[dataIndex]?.condition) {
                var inputvalue = e.target.value;
                const cond = { ...FilterArray[index][dataIndex].condition };
                if (cond['value'] != undefined) {
                    cond.value = inputvalue;
                    FilterArray[index][dataIndex].condition = cond;
                }
                setFilterArray([...FilterArray]);
            }
        }
        setOriginalFilters([...allfilterArray]);
    }

    useEffect(() => {
        // console.log("check filter data ==", data, FilterArray);
        var merged = [].concat.apply([], FilterArray);
        var filterInc = 1;
        var filtersJson = {};
        var newfilterjsonData = {};
        let ForOperatoritem = []
        forms.map((form, index) => {
            const filtersCount = filters.reduce((acc, cur) => acc + cur.length, 0);
            return (
                filters[index] && filters[index].map((val, j) => {
                    ForOperatoritem.push(MockData[((index) * filtersCount) + j]);
                })
            )
        })

        merged.map((row, index) => {
            if (row?.checked == true) {
                var operatorVal = null;
                if (filterInc > 1) {
                    operatorVal = ForOperatoritem[index - 1]?.operator !== "null" ? ForOperatoritem[index - 1]?.operator : "and";
                }
                newfilterjsonData["filter" + filterInc] = { form_id: researchTableData.find(i => i.form_name === row.form_name)?.form_id, form_name: row.form_name, condition: row.condition, operator: operatorVal };
                filterInc += 1;
            }
        });
        filtersJson = newfilterjsonData;
        dispatch(addFilter(filtersJson));
    }, [FilterArray]);

    // const valueChange = (elem, e) => {
    //     const arr = [...data];
    //     arr.map(item => {
    //         if (item.id == elem.id) {
    //             item.value = e.target.value
    //         }
    //         return item
    //     })
    //     setData(arr)
    // }

    const deleteCondition = (key, val) => {
        var changedFilters = filters;
        let filteredArray = changedFilters[key].filter(item => item !== val);
        changedFilters[key] = filteredArray;
        setFilters([...changedFilters]);
    }

    const toggleCollapse = () => setIsCollapseOpen((prev) => !prev);
    // console.log("filter array ===", FilterArray);
    var ValueInc = 0;

    return (
        <div className="recent-activities filter_section">
            <div className="d-flex justify-content-between border-bottom heading-select py-2 items-center">
                <h3 className="m-0 p-0 border-0">Filtres</h3>
                <Button color="light" onClick={toggleCollapse}>
                    <i
                        className={`font-bold text-lg ${!isCollapseOpen ? "ti-plus" : "ti-minus"}`}
                    />
                </Button>
            </div>
            <Collapse isOpen={isCollapseOpen}>
                {forms.map((form, index) => {
                    const filtersCount = filters.reduce((acc, cur) => acc + cur.length, 0);
                    return (
                        <>
                            {
                                filters[index] && filters[index].map((val, j) => {
                                    const item = MockData[((index) * filtersCount) + j];
                                    const ForOperatoritem = MockData[((index) * filtersCount) + j];
                                    // const ForOperatoritem = MockData[(index * filtersCount) + j - 1];
                                    // console.log("ForOperatoritem +>", ForOperatoritem)
                                    // console.log("filtersCount +>", filtersCount)
                                    var filtersContent1 = { form_index: index, data_index: j, checked: item.checked, form_id: "", form_name: form, condition: { column: val, operator: item.conditionoperator, value: item.value } };
                                    // if(ValueInc > 0)
                                    // {
                                    filtersContent1.operator = ForOperatoritem?.operator;
                                    // }
                                    // else{ 
                                    //     filtersContent1.operator = "null"
                                    // }  
                                    var filtersContent1Array = [...FilterArray];
                                    if (!filtersContent1Array[index]) {
                                        filtersContent1Array[index] = [];
                                    }
                                    if (!filtersContent1Array[index][j]) {
                                        filtersContent1Array[index][j] = filtersContent1;
                                        setFilterArray([...filtersContent1Array]);
                                    }
                                    ValueInc += 1;

                                    return <>
                                        <div className="d-flex filter-sec">
                                            <div className="flex gap-2">
                                                <div className="flex gap-2 items-center" >
                                                    <h5 className="p-2 rounded-md" style={{ background: colors[index % 4] }}>{form}</h5>
                                                    <h5 className="p-2 rounded-md " style={{ background: colors[index % 4] }}>{val}</h5>
                                                </div>

                                                <div className="flex items-center" style={{ flex: 0 }}>
                                                    <Switch onChange={(e) => handleChange(e, item, form, val, index, 'Checked', j, !item?.checked)} checked={item?.checked} />
                                                </div>
                                            </div>
                                            <select className="andor-select mx-10" onChange={(e) => handleChange(e, item, form, val, index, 'ConditionOperator', j)}>
                                                <option value="lt" selected={item.conditionoperator == 'lt' ? true : false}>{"<"}</option>
                                                <option value="gt" selected={item.conditionoperator == 'gt' ? true : false}>{">"}</option>
                                                <option value="eq" selected={item.conditionoperator == 'eq' ? true : false}>{"="}</option>
                                                <option value="neq" selected={item.conditionoperator == 'neq' ? true : false}>{"!="}</option>
                                                <option value="gte" selected={item.conditionoperator == 'gte' ? true : false}>{">="}</option>
                                                <option value="lte" selected={item.conditionoperator == 'lte' ? true : false}>{"<="}</option>
                                            </select>
                                            <div>
                                                <input disabled={!item?.checked} onChange={(e) => handleChange(e, item, form, val, index, 'ValueChange', j)} type="text" name="filter" value={item?.value} placeholder="Entrer valeur" />
                                            </div>
                                            {/* <div className="flex items-center justify-between"> */}
                                            {/* <button type="button" onClick={() => deleteCondition(index,val)} className="remove-btn text-white bg-red-600 p-1 px-2 rounded" title="delete"><i className="ti-trash"></i></button> */}
                                            {/* </div> */}
                                        </div>

                                        {(index * filters.length) + j < filtersCount - 1 && <select className="andor-select mt-3" onChange={(e) => handleChange(e, item, form, val, index, 'OperatorChange', j)}>
                                            <option value="and" selected={item.operator == 'and' ? true : false}>AND</option>
                                            <option value="or" selected={item.operator == 'or' ? true : false}>OR</option>
                                        </select>}
                                    </>
                                }
                                )
                            }

                        </>
                    )
                })}
            </Collapse>

        </div>
    )
}

export default Filters
